import React from 'react'
import { Container } from '@abw/badger-ui'
import CakeSVG from '../promotion/feb-2023/Cake.jsx'

export const February = () =>
  <Container className="">
    <div className="animated-banner no-roll text-center mar-b-4">
      <CakeSVG width="320"/>
    </div>
    <h1>It's our 15th Birthday!</h1>

    <p className="largish">
      To celebrate, we're offering <b className="orange">15% off</b> all our
      hire prices when you book a hire in February
      with a start date in <b className="orange">February 2023</b>.
      The 15% hire price discount will be added automatically
      at checkout. It's as easy as that!
    </p>
    <p>
      Subject to availability. Not valid in conjunction with any other
      discount codes. Normal Terms and Conditions apply.
    </p>
  </Container>

export default February